import type { ReactNode } from 'react';

// Card frame shared by the Personal-tab sections (Person Details, Contacts, Address, Emergency).
// Header shows a title + optional description on the left and an action slot (e.g. Add/Edit) on
// the right; the body holds the section content. Styled with Mango semantic tokens.
interface SectionShellProps {
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
}

export const SectionShell = ({ title, description, action, children }: SectionShellProps) => (
  <section className="mgo-background-raised mgo-border-neutral mgo-radius-strong">
    <div className="mgo-split mgo-align-center" style={{ padding: 'var(--mgo-space-40)', borderBottom: 'var(--mgo-border-neutral)' }}>
      <div className="mgo-stack mgo-gap-2xs" style={{ minWidth: 0 }}>
        <h3 className="mgo-text-m mgo-weight-strong" style={{ margin: 0 }}>{title}</h3>
        {description && <p className="mgo-text-s mgo-color-muted" style={{ margin: 0 }}>{description}</p>}
      </div>
      {action && <div className="mgo-cluster mgo-gap-s" style={{ flexShrink: 0 }}>{action}</div>}
    </div>
    <div style={{ padding: 'var(--mgo-space-40)' }}>{children}</div>
  </section>
);

/** A label/value pair used inside section read views. */
export const DetailPair = ({ label, value }: { label: string; value?: ReactNode }) => (
  <div className="mgo-stack mgo-gap-2xs">
    <span className="mgo-text-xs mgo-color-muted">{label}</span>
    <span className="mgo-text-s">{value || '—'}</span>
  </div>
);
